import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/mezzi.json"
import { ROLES } from "constant";

export default class Mezzi extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: []
        };
    }

    render() {

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Gestione mezzi"}
                    icon={"local_shipping"}
                />
                <MDBox>
                    <MyDataTable
                        tableData={tableData}
                        edit={[ROLES.admin, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        delete={[ROLES.admin, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        add={[ROLES.admin, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        icon={"Personale"}
                    />
                </MDBox>

            </DashboardLayout>
        )
    }
}


